import { render, staticRenderFns } from "./mainIndex.vue?vue&type=template&id=3d2fcfac&scoped=true&"
import script from "./mainIndex.vue?vue&type=script&lang=js&"
export * from "./mainIndex.vue?vue&type=script&lang=js&"
import style0 from "./mainIndex.vue?vue&type=style&index=0&id=3d2fcfac&lang=scss&scoped=true&"
import style1 from "./mainIndex.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2fcfac",
  null
  
)

export default component.exports